import { useEffect, useMemo, useState } from "react"
import { useAppSelector } from "../redux/hook";
import { shared_documents_list } from "../utils/shared/documents-list";
import { DocumentItem } from "../models/polymer/Document.model";
import { OwnershipReasonEnum } from "../models/enum/ownership-reason.enum";
import { HouseholdFormData, ReasonFormData } from "../models/classes/ApplicationStep1.class";
import { Helpers } from "../utils/helper";
import { ResidentialStatusEnum } from "../models/enum/residential-status.enum";
import { LoanTypeEnum } from "../models/enum/loan-type.enum";
import { checkDOB, convertRoleToStructureStatus } from "../utils/form-helper";
import { SolicitorTypeEnum } from "../models/enum/solicitor-type.enum";
import { MyInfo, MyInfoWithDOD } from "../models/polymer/MyInfo.model";
import { HoldingTypeEnum } from "../models/enum/holding-type.enum";
import { ChildrenCareControlEnum } from "../models/enum/children-care-control.enum";
import { Owner } from "../models/polymer/Owner.model";
import { MaritalStatusEnum } from "../models/enum/marital-status.enum";
import { Occupier } from "../models/polymer/Occupier.model";
import { StructureStatusEnum } from "../models/enum/structure-status.enum";
import { ApplicationStep2 } from "../models/classes/ApplicationStep2.class";
import { DemiseAdministratorDoc } from "../models/enum/demise-administrator-doc.enum";
import { ApplicationStep3 } from "../models/classes/ApplicationStep3.class";
import { ApplicationStart } from "../models/classes/ApplicationStart.class";
import { PolymerAxios } from "../utils/axios";
import { API_CheckPersonRecords } from "../utils/api";
import { PolymerCrypto } from "../utils/encryptor";

  /**
   * @description check the proposed ownership citizenship is empty 
   * @param household The household data from the Step 2,
   * @param document_item the document type item
   * @returns array of DocumentItem[]
   */
  const checkProposedOwnerCitizenship = (household: HouseholdFormData, document_item:DocumentItem):DocumentItem[] => {
    let temp_documents:DocumentItem[] = [];
    household.incoming_owners?.forEach((owner)=>{
      //!NOTE: Currently check residential_status, no citizenship field currently
      if(owner.myinfo && (!owner.myinfo?.residential_status || owner.myinfo?.residential_status === ResidentialStatusEnum.not_applicable)){
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
        temp_documents.push(document_obj);
      }
    });

    return temp_documents;
  }

    /**
   * @description check the proposed ownership is SPR. 
   * @param household The household data from the Step 2,
   * @param document_item the document type item
   * @returns array of DocumentItem[]
   * @logic based on Jira-377 
   * - For SC-SPR Proposed Household, for SPR Proposed Owner, there is no need for applicant to upload the Entry/Re-Entry permit.
   * - Only for All SPR Proposed Household, for SPR Proposed Owner(s), applicant needs to upload the Entry/Re-Entry Permit.
   * 
   * @logic_change based on JIRA-478
   * - For MVP - we will request for entry/re-entry permit as long as there is SPR listed as owner / essential occupier. Not limited to only SPR households.
   */
  
    const checkStageAOccupiersPermanentResident = (household: HouseholdFormData, document_item:DocumentItem):DocumentItem[] => {
      
      let temp_documents:DocumentItem[] = [];
      // const owners:Owner[] = [...household.incoming_owners];
      const occupiers:Occupier[] = [...household.incoming_occupiers];
      
      // owners?.filter(e=>e.myinfo.residential_status === ResidentialStatusEnum.pr).forEach((owner)=>{
      //   let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
      //   temp_documents.push(document_obj);
      // });

      occupiers?.filter(e=>e.myinfo.residential_status === ResidentialStatusEnum.pr).forEach((occupier)=>{
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, occupier.myinfo.name)});
        temp_documents.push(document_obj);
      });
      
      return temp_documents;
      
    }
    const checkStageAMainApplicantPermanentResident = (loginUser:MyInfo, household: HouseholdFormData, document_item:DocumentItem):DocumentItem[] => {
      
      let temp_documents:DocumentItem[] = [];
      
      const owners:Owner[] = [...household.incoming_owners];
      
      owners?.filter(e=> (e.myinfo.uinfin === loginUser.uinfin && e.myinfo.residential_status === ResidentialStatusEnum.pr)).forEach((owner)=>{
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
        temp_documents.push(document_obj);
      });
      
      return temp_documents;
    }


     /**
   * @description check incoming occupiers has foreigners.
   * @param household The household data from the Step 2,
   * @param document_item the document type item
   * @returns array of DocumentItem[]
   */
  const checkOccupiersHasForeigner = (household: HouseholdFormData, document_item:DocumentItem):DocumentItem[] => {
    let temp_documents:DocumentItem[] = [];
    
    household.incoming_occupiers?.forEach((owner)=>{
      if(owner.myinfo && owner.myinfo?.residential_status === ResidentialStatusEnum.not_applicable){
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
        temp_documents.push(document_obj);
      }
    });

    return temp_documents;
  }


     /**
   * @description check incoming occupiers is 70 Yo to display DC12.
   * @param household The household data from the Step 2,
   * @param document_item the document type item
   * @returns array of DocumentItem[]
   */
  // const checkAskForMentalCapacity = (household: HouseholdFormData, document_item:DocumentItem, applicationStep3FormData?: ApplicationStep3, additional_roles?: MyInfoWithDOD[]):DocumentItem[] => {
  //   let temp_documents:DocumentItem[] = [];
  //   const ownersToAskForMentalCapacity: Owner[] = [];
  //   const executorsOrAdmins = additional_roles?.filter((data) => data.role_name === "Executor" || data.role_name === "Administrator")

  //   if((applicationStep3FormData?.current_solicitor_type === SolicitorTypeEnum.hdb_solicitor 
  //     && applicationStep3FormData?.current.hdb_solicitor.represented_same_solicitor === true )
  //     || applicationStep3FormData?.current_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor){

  //     for(const owner of household.owners) {
  //       const isAlreadyAdded = ownersToAskForMentalCapacity.some(addOwner => addOwner.myinfo.uinfin === owner.myinfo.uinfin);
  //       const isExecutorOrAdmin = executorsOrAdmins?.some((myInfoData) => myInfoData.uinfin === owner.myinfo.uinfin);
  //       const isOwnerAlive = owner.live_status === "A";

  //       if(!isAlreadyAdded && checkDOB(owner.myinfo.dob, 70) && !isExecutorOrAdmin && isOwnerAlive) {
  //         ownersToAskForMentalCapacity.push(owner);
  //       }
  //     }
  //   }

  //   if((applicationStep3FormData?.proposed_solicitor_type === SolicitorTypeEnum.hdb_solicitor 
  //     && applicationStep3FormData?.proposed.hdb_solicitor.represented_same_solicitor === true) 
  //     || applicationStep3FormData?.proposed_solicitor_type === SolicitorTypeEnum.conveyancing_hdb_solicitor){
  //     for(const owner of household.incoming_owners){
  //       const isAlreadyAdded = ownersToAskForMentalCapacity.some(addOwner => addOwner.myinfo.uinfin === owner.myinfo.uinfin);
  //       const isExecutorOrAdmin = executorsOrAdmins?.some((myInfoData) => myInfoData.uinfin === owner.myinfo.uinfin);
  //       const isOwnerAlive = owner.live_status === "A";
        
  //       if(!isAlreadyAdded && checkDOB(owner.myinfo.dob, 70) && !isExecutorOrAdmin && isOwnerAlive) {
  //         ownersToAskForMentalCapacity.push(owner);
  //       }
  //     }
  //   }

  //   ownersToAskForMentalCapacity?.forEach((owner)=>{
  //     let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
  //     temp_documents.push(document_obj);
  //   });

  //   return temp_documents;
  // }

    /**
   * @description check retaining owners that are previously divorced.
   * @param household The household data from the Step 2
   * @param document_item the document type item
   * @param applicationStartFormData data fetched for the selected property
   * @returns array of DocumentItem[]
   */
  const checkDivorcedRetainingOwner = (household: HouseholdFormData, document_item:DocumentItem, applicationStartFormData: ApplicationStart):DocumentItem[] => {
    let temp_documents:DocumentItem[] = [];
    const retainingOwners = household.incoming_owners.filter(item => item.structure_status === StructureStatusEnum.retaining);
    retainingOwners.forEach((owner) => {
      const originalOwner = applicationStartFormData.selected_hdb_property?.owners.find(item => item.uinfin === owner.myinfo.uinfin);
      if(originalOwner && originalOwner.marital_status === MaritalStatusEnum.divorced){
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, owner.myinfo.name)});
        temp_documents.push(document_obj);
      }
    })

    return temp_documents;
  }
  
  const checkDivorcedAllCurrentOwner = (currentOwners: MyInfoWithDOD[], document_item:DocumentItem, prefix?:string):DocumentItem[] => {
    let temp_documents:DocumentItem[] = [];
    currentOwners.forEach((owner) => {
      if(owner.marital_status === MaritalStatusEnum.divorced){
        let document_obj = new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, `${prefix}${owner.name}` )});
        temp_documents.push(document_obj);
      }
    })

    return temp_documents;
  }

  const checkPromptingMarriageCert = (household: HouseholdFormData, applicationStartFormData: ApplicationStart, document_item: DocumentItem) => {
    const currentHouseholdPersonalDetails = applicationStartFormData?.selected_hdb_property?.owners.map(item => {
      return {
        uinfin: item.uinfin,
        name: item.name,
        marital_status: item.marital_status
      }
    }).concat(applicationStartFormData?.selected_hdb_property?.occupiers.map(item => {
      return {
        uinfin: item.uinfin,
        name: item.name,
        marital_status: item.marital_status
      }
    })) ?? [];

    console.log("currentHouseholdPersonalDetails",currentHouseholdPersonalDetails)

    const proposedHouseholdPersonalDetails = household.incoming_owners.map(item => {
      return {
        uinfin: item.myinfo.uinfin,
        name: item.myinfo.name,
        marital_status: item.myinfo.marital_status,
        spouse_uinfin: item.spouse
      }
    }).concat(household.incoming_occupiers.map(item => {
      return {
        uinfin: item.myinfo.uinfin,
        name: item.myinfo.name,
        marital_status: item.myinfo.marital_status,
        spouse_uinfin: item.spouse
      }
    })) ?? [];

    console.log("proposedHouseholdPersonalDetails",proposedHouseholdPersonalDetails)

    const personsToPromptMarriageCert = proposedHouseholdPersonalDetails.filter(proposed => {
      const currentMaritalStatus = currentHouseholdPersonalDetails.find(current => current.uinfin === proposed.uinfin)?.marital_status;
      const proposedMaritalStatus = proposed.marital_status;
      if(proposedMaritalStatus !== MaritalStatusEnum.married){
        return false
      }

      //only if proposed marital status is married will be considered of prompting marriage cert
      if(currentMaritalStatus !== MaritalStatusEnum.married){
        return true;
      }

      const spouseInCurrentHousehold = currentHouseholdPersonalDetails.some(item => item.uinfin === proposed.spouse_uinfin);
      if(!spouseInCurrentHousehold) {
        return true;
      }

      return false;
    })

    const marriageCertsForPairs: {
      uinfin: string,
      name: string,
      spouse_uinfin: string,
      spouse_name: string
    }[] = [];

    for(const person of personsToPromptMarriageCert){
       const checkIsIncluded = marriageCertsForPairs.some(item => item.uinfin === person.uinfin || item.spouse_uinfin === person.uinfin);
       if(checkIsIncluded){
        continue;
       }

       marriageCertsForPairs.push({
        uinfin: person.uinfin,
        name: person.name,
        spouse_uinfin: person.spouse_uinfin,
        spouse_name: proposedHouseholdPersonalDetails.find(item => item.uinfin === person.spouse_uinfin)?.name ?? ""
       })
    }

    console.log(marriageCertsForPairs)
    const processedDocuments: DocumentItem[] = [];
    for(const pair of marriageCertsForPairs){
       processedDocuments.push(new DocumentItem({...document_item, label: `${document_item.label} of ${pair.name} and ${pair.spouse_name}`}))
    }
    return processedDocuments;
  }

  const checkPromptingTitleDeed = (applicationStep2FormData: ApplicationStep2, document_item: DocumentItem, address: string) => { 
    let currentLoanAmount = 0;
    if(applicationStep2FormData?.current_loan_amount !== undefined){
        currentLoanAmount = Number(applicationStep2FormData?.current_loan_amount);
    }
    const documents = [new DocumentItem({...document_item, label : Helpers.formatDocumentListTitle(document_item.label, '', address)})];
    if(applicationStep2FormData?.current_loan_type === LoanTypeEnum.bank_loan && !isNaN(currentLoanAmount) && currentLoanAmount === 0){
      return documents;
    }

    if(applicationStep2FormData?.current_loan_type === LoanTypeEnum.no_loan) {
       return documents;
    }
    
    return []
  }

const handleDocumentsForReasons = (household: HouseholdFormData, reason: ReasonFormData, additionalData: any, currentHoldingType: HoldingTypeEnum | undefined, lastWillIsChecked?: boolean) => {
    if(reason.change_ownership_reason === OwnershipReasonEnum.moving_out_due_to_marriage){
        return getMovingOutMarriageDocuments(reason);
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.moving_out_others && !additionalData.titleDeedFoundByHDB && additionalData.loanConditions){
        return getMovingOutOtherDocuments();
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.divorce){
        return getDivorceDocuments(household, reason);
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.medical){
        return getMedicalDocuments(additionalData.loginUser);
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.renunciation){
        return getRenunciationDocuments(household);
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.demise_of_current_owner){
        return getDemiseDocuments(household, reason, currentHoldingType, additionalData.additional_roles ?? [], lastWillIsChecked ?? false);
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.inclusion_due_to_marriage && additionalData.isOwnerRetaining){
        return getInclusionMarriageDocuments();
    }else if(reason.change_ownership_reason === OwnershipReasonEnum.financial_difficulties){
        return getFinancialDifficultiesDocuments(additionalData.currentLoanType);
    }

    return [];
}

interface GeneralDocumentsData {
  applicationStep2FormData?: ApplicationStep2;
  address?: string;
  applicationStep3FormData?: ApplicationStep3;
  reason?: ReasonFormData;
  applicationStartFormData?: ApplicationStart;
}

const handleGeneralDocuments = async (
    household: HouseholdFormData, 
    loginUser: MyInfo,
    singpassToken: string,
    privateSolicitorIndicated: boolean, 
    isDebarment: boolean,
    data: GeneralDocumentsData) => {
    let documents: DocumentItem[] = [];
    const documentsCodes = ["DC02", "DC03", "DC04", "DC06", "DC07", "DC09" ,"DC10", "DC13", "DC15", "DC24", "DC27", "DC29"];
    //DC02 - Identity Documents for <<Name>>
    //DC03 - SPR Entry / re-entry Permit <<Name>>
    //DC04 - Long Term Visit Pass/ Social Visit Pass <<Name>>
    //DC06 - Title Deed (Duplicate) for <<Address>>
    //DC07 - Bank's Letter of Offer 
    //DC08 - Bank's Letter of Acceptance (COMBINED TO DC07)
    //DC09 - Letter of Solicitor's Representation
    //DC10 - Consent from Official Assignee or Bankruptcy Discharge Certificate
    //DC12 - Doctor's Memo certifying mental capacity for <<Name>> (has been removed JIRA-923)
    //DC13 - Order of Court or Decree stating the settlement of the matrimonial property
    //DC14 - Interim Judgement (Combined to DC13)
    //DC24 - Proof of relationship
    //DC27 - Marriage Certificate
    //DC29 - Interim Judgement/ Order of Court or Decree of <<Name>>

    const generalDocuments = shared_documents_list.filter(item => documentsCodes.includes(item.code));

    documents = documents.concat(checkStageAMainApplicantPermanentResident(loginUser, household, generalDocuments.find(item => item.code === "DC03")!));
    documents = documents.concat(checkStageAOccupiersPermanentResident(household, generalDocuments.find(item => item.code === "DC03")!));
    documents = documents.concat(checkOccupiersHasForeigner(household,  generalDocuments.find(item => item.code === "DC02")!));
    documents = documents.concat(checkOccupiersHasForeigner(household,  generalDocuments.find(item => item.code === "DC04")!));
    // documents = documents.concat(checkAskForMentalCapacity(household, generalDocuments.find(item => item.code === "DC12")!, applicationStep3FormData, applicationStartFormData?.selected_hdb_property?.additional_roles));
    
    documents = documents.concat(checkPromptingTitleDeed(data.applicationStep2FormData!, generalDocuments.find(item => item.code === "DC06")!, data.address ?? ''));
    
    if(data.applicationStep2FormData?.new_loan_type === LoanTypeEnum.bank_loan){
        documents = documents.concat(generalDocuments.filter(item => item.code === "DC07"));
    }

    if(privateSolicitorIndicated){
        documents.push(generalDocuments.find(item => item.code === "DC09")!);
    }

    if(isDebarment){
      documents.push(generalDocuments.find(item => item.code === "DC10")!);
    }
    
    const proposedOwnersWithBrotherOrSisterRelationship = household.incoming_owners.filter(e=>e.relationship_with_owner === "BS");
    if(proposedOwnersWithBrotherOrSisterRelationship.length !== 0){
      const encryptedUinfins = proposedOwnersWithBrotherOrSisterRelationship.map(owner => PolymerCrypto.encryption(owner.myinfo.uinfin));

      const response = await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(`${API_CheckPersonRecords}`, {uinfins: encryptedUinfins});

      if (response.status !== 200 || encryptedUinfins.length !== response.data.uinfins.length) {
        documents.push(generalDocuments.find(item => item.code === "DC24")!);
      }
    }

     documents = documents.concat(checkPromptingMarriageCert(household, data.applicationStartFormData!, generalDocuments.find(item => item.code === "DC27")!));

    if(data.reason && data.reason.change_ownership_reason !== OwnershipReasonEnum.divorce){
      documents = documents.concat(checkDivorcedAllCurrentOwner(data.applicationStartFormData?.selected_hdb_property?.owners ?? [] ,generalDocuments.find(item => item.code === "DC29")!, ''));
      documents = documents.concat(checkDivorcedAllCurrentOwner(data.applicationStartFormData?.selected_hdb_property?.owners ?? [] ,generalDocuments.find(item => item.code === "DC15")!, `for `));
    }

    return documents;
}

const getMovingOutMarriageDocuments = (reason: ReasonFormData) => {
  //DC01 - Notice of Marriage
  if(reason.date_of_marriage && new Date(reason.date_of_marriage).toISOString().split("T")[0] >= new Date().toISOString().split("T")[0]){
      return shared_documents_list.filter(item => item.code === 'DC01');
  }

  return []
}

const getMovingOutOtherDocuments = () => {
  return[]
}

const getInclusionMarriageDocuments = () => {
  return [];
}

const getFinancialDifficultiesDocuments = (currentLoanType: LoanTypeEnum) => {
  //DC28 - Arrears Letter from Bank
  
  let documents: DocumentItem[] = [];
  
  if(currentLoanType === LoanTypeEnum.bank_loan){
    documents = documents.concat(shared_documents_list.filter(item => item.code === "DC28"))
  }
  return documents;
}

const getDivorceDocuments = (household: HouseholdFormData, reason: ReasonFormData) => {
  //DC13 - Order of Court or Decree stating the settlement of the matrimonial property
  //DC14 - Interim Judgement
  //DC15 - Final Judgement
  //DC16 - Consent Letter from CPF on CPF refund
  //DC17 - CPF Board's written confirmation on Court Orders
  //DC18 - Owners' written consent for Shared Parental Control

  let documents:DocumentItem[] = [];
  let divorceDocumentsCodes = ["DC13"];
  if(reason.cpf_refund !== "full"){
     divorceDocumentsCodes.push("DC16");
  }
  /**
   * NOTE: When it is shared_control_children, then ask for DC18.
   */
  const isSharedParentalControlNeeded = household.incoming_owners.some(e=>(e.children_care_and_control === ChildrenCareControlEnum.shared_control_children));
  if(isSharedParentalControlNeeded){
    divorceDocumentsCodes.push("DC18");
  }

  documents = documents.concat(shared_documents_list.filter(item => divorceDocumentsCodes.includes(item.code)));

  if(reason.have_final_judgement === "yes") {
    let documentDC15 = shared_documents_list.find(item => item.code === "DC15")!
    documents = documents.concat(new DocumentItem({...documentDC15, label : Helpers.formatDocumentListTitle(documentDC15.label, ` `)}));
  }
  return documents;
}

const getMedicalDocuments = (loginUser:MyInfo) => {
  //DC11 - Doctor's Memo for details of Health Condition
  //DC25 - Doctor's Memo explaining medical condition for <<Name>>
  
  let documents = shared_documents_list.filter(item => item.code === 'DC11');

  // let Dc25document = shared_documents_list.find(item => item.code === 'DC25');
  // if(Dc25document){
  //   documents = documents.concat(new DocumentItem({...Dc25document, label : Helpers.formatDocumentListTitle(Dc25document.label, loginUser.name)}));
  // }
  
  return documents;
}

const getRenunciationDocuments = (household: HouseholdFormData) => {

  //NOTE: currently these documents will always return empty array as non citizen/pr owner will not be able to be added in Step A1
  const processingDocuments = shared_documents_list.filter(item => item.code === "DC05");
  const processedDocuments = processingDocuments.map(item => checkProposedOwnerCitizenship(household, item)).flat(1);
  return processedDocuments;
};

const getDemiseDocuments = ( household: HouseholdFormData, reason: ReasonFormData, currentHoldingType: HoldingTypeEnum | undefined, additional_roles: MyInfoWithDOD[], lastWillIsChecked: boolean) => {
    //DC19 - Death Certificate
    //DC20 - Schedule of Assets
    //DC21 - Grant of Probate/Inheritance Certificate
    //DC22 - Letter of Administration
    //DC23 - Last Will

    // //LOGIC : when is joint-tenancy, no need to ask for DC20, DC21, DC22, DC23.
    const demiseDocumentsCodes = ["DC19", "DC20", "DC21", "DC22","DC23"];
    const demiseDocuments = shared_documents_list.filter(item => demiseDocumentsCodes.includes(item.code));
    const documents: DocumentItem[] = [];

    const isThereAnyExecutorOrAdmin = additional_roles?.some((additionalRole) => additionalRole.role_name === "Executor" || additionalRole.role_name === "Administrator");
    if(!isThereAnyExecutorOrAdmin) {
      documents.push(demiseDocuments.find(item => item.code === "DC19")!);
    }

    if (reason.has_administration_items === DemiseAdministratorDoc.grant_probate_with_last_will) {
      documents.push(demiseDocuments.find(item => item.code === "DC20")!);
      documents.push(demiseDocuments.find(item => item.code === "DC21")!);
      documents.push(demiseDocuments.find(item => item.code === "DC23")!);
    } else if (reason.has_administration_items === DemiseAdministratorDoc.letter_of_administration) {
      documents.push(demiseDocuments.find(item => item.code === "DC20")!);
      documents.push(demiseDocuments.find(item => item.code === "DC22")!);
    }

    return documents;
}

export const usePrepareDocuments = (stage: "A" | "B" = "A") => {
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const applicationStartFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const applicationStep2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const applicationStep3FormData = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const applicationStep4FormData = useAppSelector(state => state.app.ApplicationStep4Slice.formData);

  const address = applicationStartFormData.selected_hdb_property?.address;

  const [ isPreparing, setPreparing ] = useState<boolean>(true);
  const [ documentList, setDocumentList ] = useState<DocumentItem[]>([]);
  const [ initialDocuments, setInitialDocuments ] = useState<DocumentItem[]>([]);
  const [ lastWillIsChecked, setLastWillIsChecked] = useState<boolean>(false);

  const updateLastWillIsChecked = (additionalCheckbox: string[]) => {
    if(additionalCheckbox.includes("Last Will")){
      setLastWillIsChecked(true);
    } else {
      setLastWillIsChecked(false);
    }
  }


  const submittedDocuments = useMemo(()=>{
    const resubmitDocumentCode = []
    return applicationStep4FormData.file_items.filter(e=> e.file_id || e.key).map(e=>{ return {label:e.label, code: e.code}});
  },[applicationStep4FormData.file_items]);


  const currentHoldingType = useMemo(()=>{
    return applicationStartFormData.selected_hdb_property?.holding_type;
  },[applicationStartFormData.selected_hdb_property?.holding_type])

  /**
   * @description to check whether the login owner is retaining.
   * @param household The household data from the Step 2
   * @returns true or false
   */
  const isOwnerRetaining = (household: HouseholdFormData):boolean =>{
    const isUserRetaining = household.incoming_owners.find((owner)=> owner.myinfo.uinfin === loginUser.uinfin);
    return isUserRetaining !== undefined;
  }

  const rearrangeDocuments = (documents: DocumentItem[]) => {
    //To put files with same name together
    const documentCodesToBeSorted = ["DC02", "DC05"];
    const documentsToBeSorted = documents.filter(item => documentCodesToBeSorted.includes(item.code));
    const finalDocuments = documents.filter(item => !documentCodesToBeSorted.includes(item.code));
    let temp: DocumentItem[] = [];

    let names = documentsToBeSorted.map(item => {
        const substringKey = item.code === "DC02" ? "for" : "of";
        const name = item.label.substring(item.label.indexOf(substringKey) + substringKey.length + 1, item.label.length);
        return name;
    });
    names = names.filter((item, index) => names.findIndex(name => name === item) === index);
    for(const name of names){
      temp = temp.concat(documentsToBeSorted.filter(item => item.label.includes(name)));
    }

    const processedDocuments = temp.concat(finalDocuments);
    return processedDocuments.filter((item, index) => index === processedDocuments.findIndex(doc => doc.label === item.label));//remove duplicate
  }

  const removeSubmittedDocumentation = (documents: DocumentItem[]) =>{

    //NOTE : DEMISE CHECKING, if submittedDocuments have DC22, mean remove DC21, DC23
    let filtered_documents = documents.filter(e=> !submittedDocuments.map(e=>e.label).includes(e.label))

    if(submittedDocuments.some(e=> e.code === "DC22")){
      const demiseDocumentCodeToRemove = ["DC21", "DC23"];
      filtered_documents = filtered_documents.filter(e=> !demiseDocumentCodeToRemove.includes(e.code));
    }

    //NOTE : WHEN BANK LOAN DOCS SUBMITTED, then no need to ask any more
    const bankLoanDocuments = ["DC07", "DC09"];
    filtered_documents = filtered_documents.filter(e=> !bankLoanDocuments.includes(e.code));

    filtered_documents = filtered_documents.filter(e=>e.code !== "DC06")

    return filtered_documents;
  }

  const removeD11andD12SubmittedDocuments = (documents: DocumentItem[]) =>{

    let filtered_documents = documents;
    const documentCodeToRemove = ["DC11", "DC12"];
    filtered_documents = filtered_documents.filter(e=> !documentCodeToRemove.includes(e.code));

    return filtered_documents;
  }

  const processDocumentation = async (lastWillIsChecked: boolean) =>{
    const titleDeedFoundByHDB = false; //NOTE : based on xmind, title deed must be found by HDB, How do we know if Deed found?
    const noLoanDetectedSMSAPI = true;
    const loanConditions = (applicationStep2FormData.current_loan_type === LoanTypeEnum.bank_loan && Helpers.formatStringToNumber(applicationStep2FormData.current_loan_amount) === 0) || noLoanDetectedSMSAPI;
    const solicitors = [applicationStep3FormData.current_solicitor_type, applicationStep3FormData.proposed_solicitor_type];
    const privateSolicitorIndicated = solicitors.includes(SolicitorTypeEnum.private_solicitor) || solicitors.includes(SolicitorTypeEnum.conveyancing_private_solicitor);  // Check on private solicitors for both current and proposed?
    const isDebarment = applicationStartFormData.isDebarred;

    const generalDocumentsData: GeneralDocumentsData = {
      applicationStep2FormData: applicationStep2FormData,
      address: address,
      applicationStep3FormData: applicationStep3FormData,
      reason : applicationStep1FormData.reason,
      applicationStartFormData: applicationStartFormData
    }

    let temp_documents:DocumentItem[] = [];
    temp_documents = temp_documents.concat(handleDocumentsForReasons(applicationStep1FormData.household, applicationStep1FormData.reason, {
      isOwnerRetaining: isOwnerRetaining(applicationStep1FormData.household),
      titleDeedFoundByHDB: titleDeedFoundByHDB,
      loanConditions: loanConditions,
      address: address,
      allOwnersHaveDeathDate: applicationStep1FormData.household.owners.every(item => item.live_status === "D"),
      has_administration_items: applicationStep1FormData.reason.has_administration_items,
      loginUser: loginUser,
      currentLoanType : applicationStep2FormData.current_loan_type,
      additional_roles: applicationStartFormData.selected_hdb_property?.additional_roles
    }, currentHoldingType, lastWillIsChecked).concat(await handleGeneralDocuments(applicationStep1FormData.household, loginUser, singpassToken ?? '', privateSolicitorIndicated, isDebarment, generalDocumentsData)));
  

    temp_documents = rearrangeDocuments(temp_documents);
    if(stage === "B"){
      temp_documents = removeSubmittedDocumentation(temp_documents);
    }
    setDocumentList(temp_documents);
    setInitialDocuments(temp_documents);
    setPreparing(false);
  }


  const processStageBDocumentation = (new_loan_type: LoanTypeEnum, proposed_solicitor_type: SolicitorTypeEnum, isMainOutgoing: boolean, isProposedSolicitorConveyancingSameAsCurrent: boolean ) =>{
    const privateSolicitorIndicated = proposed_solicitor_type === SolicitorTypeEnum.private_solicitor || proposed_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor;
    //DC03 - SPR Entry / re-entry Permit <<Name>>
    //DC07 - Bank's Letter of Offer 
    //DC08 - Bank's Letter of Acceptance (COMBINED TO DC07)
    //DC09 - Letter of Solicitor's Representation

    let documents: DocumentItem[] = [];
    if(!isMainOutgoing){
      setDocumentList([]);
      return;
    }
    const documentsCodes = ["DC03", "DC07", "DC09"];

    const generalDocuments = shared_documents_list.filter(item => documentsCodes.includes(item.code));
    if(new_loan_type === LoanTypeEnum.bank_loan){
      documents = documents.concat(generalDocuments.filter(item => item.code === "DC07"));
    }
    if(privateSolicitorIndicated && !isProposedSolicitorConveyancingSameAsCurrent){
      
      documents = documents.concat(generalDocuments.filter(item => item.code === "DC09"));
    }
    
    //SHOW INDIVIDUAL SPR DOCUMENTS IN STAGE B
    documents = documents.concat(checkStageAMainApplicantPermanentResident(loginUser, applicationStep1FormData.household, generalDocuments.find(item => item.code === "DC03")!));

    documents = initialDocuments.concat(documents);
    documents = rearrangeDocuments(documents);
    
    // if(!isMainOutgoing){
    //   documents = removeSubmittedDocumentation(documents);
    // }
    
    // documents = removeSubmittedDocumentation(documents);

    documents = removeD11andD12SubmittedDocuments(documents);
    setDocumentList(documents);
  }

  const processDocumentsForOutgoingOwners = (applicationStep3FormData: ApplicationStep3) => {
    if(applicationStep3FormData.outgoing_solicitor_type === SolicitorTypeEnum.conveyancing_private_solicitor){
      setDocumentList(shared_documents_list.filter(item => item.code === "DC09"));
      return;
    }
    setDocumentList([]);
  }

  useEffect(()=>{
    let timeOutId : number;

    timeOutId = window.setTimeout(()=>{
      processDocumentation(lastWillIsChecked);
    },50);

    return () =>{
      clearTimeout(timeOutId);
    }
  },[ applicationStartFormData, applicationStep1FormData, applicationStep2FormData, applicationStep3FormData, lastWillIsChecked ])


  return { isPreparing, documentList, updateLastWillIsChecked, processStageBDocumentation, processDocumentsForOutgoingOwners};
}
